import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import ExportInputValuesStatus from '@app/store/transport-layer/document/export-input-values-jobs/ExportInputValuesStatus';

export interface AbortExportInputValuesJobResponse {
  id: string;
  status: ExportInputValuesStatus;
  createdAt: Date;
  updatedAt: Date;
}

export function abortExportInputValuesJob({
  workspaceId,
  jobId,
}: {
  workspaceId: string;
  jobId: string;
}) {
  return requestApi<AbortExportInputValuesJobResponse>({
    method: 'POST',
    url: withDocument(`/workspaces/${workspaceId}/export-input-values-jobs/${jobId}/abort`),
    credentials: true,
  }).then((response) => response.data);
}
